export const FETCH_DAILY_TOTAL_CALORIES_REPORTS = 'FETCH_DAILY_TOTAL_CALORIES_REPORTS';
export const FETCH_DAILY_TOTAL_CALORIES_REPORTS_FETCHING = 'FETCH_DAILY_TOTAL_CALORIES_REPORTS_FETCHING';
export const FETCH_DAILY_TOTAL_CALORIES_REPORTS_SUCCESS = 'FETCH_DAILY_TOTAL_CALORIES_REPORTS_SUCCESS';
export const FETCH_DAILY_TOTAL_CALORIES_REPORTS_FAIL = 'FETCH_DAILY_TOTAL_CALORIES_REPORTS_FAIL';

export const FETCH_WEEKLY_TOTAL_CALORIES_REPORTS = 'FETCH_WEEKLY_TOTAL_CALORIES_REPORTS';
export const FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FETCHING = 'FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FETCHING';
export const FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_SUCCESS = 'FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_SUCCESS';
export const FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FAIL = 'FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FAIL';
